import Confetti from "react-confetti";

export const PatternConfetti = () => {
  return <Confetti gravity={0.5} numberOfPieces={100} tweenDuration={2000} recycle={false} />;
};
export default PatternConfetti;
